export default __webpack_public_path__ + "media/banner_mobile_VN.12d8afa5.png";